import { render, staticRenderFns } from "./book-w1.vue?vue&type=template&id=c293aab6&"
import script from "./book-w1.vue?vue&type=script&lang=js&"
export * from "./book-w1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports